import {useSortable} from "@dnd-kit/sortable";
import React from "react";
import {CSS} from "@dnd-kit/utilities";
import {Box, Paper} from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import {sortableStyles} from "../../../styles/sortable.styles";

interface SortableItemProps {
    id: string;
    child: React.ReactNode;
}

export default function SortableItem({ id, child }: SortableItemProps) {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

    const dynamicStyle = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    return (
        <Paper
            ref={setNodeRef}
            sx={{
                position: "relative",
                ...dynamicStyle,
                ...sortableStyles.sortableItem?.sortableItemContainer,
            }}
            elevation={2}
        >
            <Box
                {...listeners}
                {...attributes}
                aria-label="Drag to reorder"
                role="button"
                tabIndex={0}
                sx={sortableStyles.sortableDraggingBox}
            >
                <DragIndicatorIcon fontSize="small" />

            </Box>

            <Box sx={sortableStyles.sortableBox}>
                {child}
            </Box>
        </Paper>
    );
}